import React, { useEffect, useState } from 'react'
import objectPath from 'object-path'
import { copyDataByCondition } from 'designer/component/action/Condition'
import { onUpdateCondition } from 'designer/component/action/condition/Action'
import { isEmpty } from 'designer/component/action/condition/State'
import { getCheckValue } from 'designer/component/action/Data'
import { getStorage } from 'designer/component/action/Storage'
import {
  updateFieldValue,
  updateMapResponse,
  updateOnChange,
  updateWidgetData,
} from './DataControl'
import PropWrapper from './PropWrapper'

const Children = ({ dataProps }) => {
  const {
    props,
    designContext,
    fieldProps,
    fieldName,
    fieldKey,
    errors,
    setIsOnChange,
  } = dataProps
  const { jsonForm, setFormData, isResetData, elementAction } = designContext
  const { uischema, config, Component } = props
  const { format, label } = uischema
  const [isRender, setIsRender] = useState(false)
  const formData = jsonForm.formData
  const {
    uiKey,
    uiName,
    value,
    data,
    defaultValue,
    renderWidget,
    mapResponse,
  } = fieldProps

  const updateData = (value, isOnChange = false, config = {}) => {
    updateFieldValue({ ...dataProps, value, isOnChange, ...config })
  }

  const updateRadioData = (value, name, isOnChange = false) => {
    updateFieldValue({ ...dataProps, name, value, isOnChange })
    setIsRender(true)
  }

  const copyData = (value) => {
    let newFormData = copyDataByCondition(value, elementAction, uiKey, formData)
    setFormData(newFormData)
  }

  useEffect(() => {
    isRender && setIsRender(false)
  }, [isRender])

  useEffect(() => {
    updateOnChange({ ...dataProps, value })
  }, [value])

  useEffect(() => {
    if (uischema.tagname === 'radio') return
    let currentValue = objectPath.get(jsonForm.formData, uiKey)
    currentValue =
      currentValue === false || currentValue === 0
        ? currentValue
        : currentValue || objectPath.get(jsonForm.formData, uiName)
    if (!isResetData && !isEmpty(currentValue)) return
    if (isEmpty(value) || isResetData) {
      let storage = getStorage(jsonForm, uiName)
      let value
      if (isEmpty(storage)) {
        value = defaultValue
      } else {
        value = storage
      }
      value = getCheckValue(value, format)
      updateData(value, false, { skipSearch: isResetData })
      onUpdateCondition(props, designContext, uiKey, data)
    }
  }, [defaultValue, isResetData])

  useEffect(() => {
    updateMapResponse(dataProps)
  }, [mapResponse])

  useEffect(() => {
    updateWidgetData(dataProps)
  }, [renderWidget])

  return (
    <>
      <Component
        fieldName={fieldName}
        fieldKey={fieldKey}
        label={label}
        uischema={uischema}
        data={data}
        value={value}
        uiKey={uiKey}
        uiName={uiName}
        updateData={updateData}
        updateRadioData={updateRadioData}
        copyData={copyData}
        errors={errors}
        config={config}
        setIsOnChange={setIsOnChange}
      />
    </>
  )
}

const ControlWrapper = (props) => {
  return (
    <PropWrapper {...props}>
      {({ dataProps }) => <Children dataProps={dataProps} />}
    </PropWrapper>
  )
}

export default ControlWrapper
